import { render, staticRenderFns } from "./ExcBreadcrumbs.vue?vue&type=template&id=0fb9e38b&scoped=true&"
import script from "./ExcBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ExcBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ExcBreadcrumbs.vue?vue&type=style&index=0&id=0fb9e38b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb9e38b",
  null
  
)

export default component.exports